import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { Text } from '@beef/ui-kit';
import {
  getFTTBAdditionalPopupConnection,
  getFTTBAdditionalPopupConnectionDataService,
  getIsNeedEmailNotEmpty,
} from 'pages/Internet/store/selectors/servicesSelectors';
import {
  continueServiceAdditionalConnection,
  setServiceAdditionalConnectionEmail,
} from 'pages/Internet/store/actions';
import {
  PopupButton, PopupInputEmail, PopupSectionPrice, PopupSectionTitle, PopupText,
  ServiceAdditional,
} from '../../../../components';

export const ConnectionTitle = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupConnection(state).title,
      shouldRender: !!getFTTBAdditionalPopupConnection(state).title,
      isTitle: true,
    }),
  ), withRenderFlag,
)(PopupText);

export const ConnectionServiceTitle = connect(
  (state) => ({
    title: getFTTBAdditionalPopupConnectionDataService(state).name,
  }),
)(PopupSectionTitle);

export const ConnectionServiceDescription = connect(
  (state) => ({
    children: getFTTBAdditionalPopupConnectionDataService(state).description,
  }),
)(ServiceAdditional);

export const ConnectionServicePrice = connect(
  (state) => ({
    children: getFTTBAdditionalPopupConnectionDataService(state).price,
  }),
)(PopupSectionPrice);

export const ConnectionEmailInput = connect(
  (state) => ({
    value: getFTTBAdditionalPopupConnection(state).email,
    placeholder: getFTTBAdditionalPopupConnection(state).emailFieldText,
    shouldRender: !!getFTTBAdditionalPopupConnection(state).needEmail,
  }),
  {
    onChange: setServiceAdditionalConnectionEmail,
  },
)(withRenderFlag(PopupInputEmail));

export const ConnectionSubmitButton = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupConnection(state).buttonText,
      shouldRender: !!getFTTBAdditionalPopupConnection(state).buttonText,
      isDisabled: !getIsNeedEmailNotEmpty(state),
    }),
    {
      onClick: continueServiceAdditionalConnection,
    },
  ), withRenderFlag,
)(PopupButton);

export const ConnectionFeeDescription = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupConnection(state).feeDescription,
      shouldRender: !!getFTTBAdditionalPopupConnection(state).feeDescription,
    }),
  ),
  withRenderFlag,
)(Text);

export const ConnectionServiceConnectedWarning = compose(
  connect(
    (state) => ({
      children: getFTTBAdditionalPopupConnection(state).serviceConnectedWarning,
      shouldRender: !!getFTTBAdditionalPopupConnection(state).serviceConnectedWarning,
    }),
  ),
  withRenderFlag,
)(Text);
